<!--
 * @Author: pengyong
 * @Date: 2020-12-14 21:13:22
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:27:09
 * @Description:
 * @FilePath: /exhibit/src/components/Empty/index.vue
-->
<template>
    <div class="empty">
        <!-- <img src="" alt="" /> -->
        <div class="text">
            {{ text }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ""
        }
    }
};
</script>

<style lang="scss" scoped>
.empty {
    margin-top: 200px;
    .text {
        font-size: 16px;
        color: #09468c;
        text-align: center;
        font-weight: 500;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Empty/index.vue